import React, {useState, useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';
import BatchesTable from './Pages/BatchesTable';
import ViewLetters from './Pages/ViewLetters';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function NBMaintenanceTabs() {
  const {nbTab} = useContext(SelectTabContextProvider);
  const classes = useStyles();
  const [value, setValue] = React.useState(nbTab ? 1 : 0);
  const [batchId, setBatchId] = useState(null);
  const [batchName, setBatchName] = useState(null);

  return (
    <div className={classes.root}>
      {/* <div>
        <AntTabs
          // className="tab-active"
          value={value}
          onChange={handleChange}
          aria-label="ant example"
          variant="scrollable"
          scrollButtons="auto"
        >
          <AntTab label="Batches" />
          <AntTab label="View Letters" />
          <AntTab label="Letters Requested" />
        </AntTabs>
        <Typography />
      </div> */}
      <div className={classes.subContent}>
        {value === 0 && (
          <BatchesTable setBatchId={setBatchId} setBatchName={setBatchName} setValue={setValue} />
        )}
        {value === 1 && (
          <ViewLetters
            batchId={batchId}
            batchName={batchName}
            setValue={setValue}
            batchView={true}
          />
        )}
        {/* {value === 2 && <LettersRequested setValue={setValue} />} */}
      </div>
    </div>
  );
}
